import React from 'react';
import { ToggleButton } from 'components';
import styles from './LabeledStatusToggleButton.module.scss';

const statusOptions = {
  NEW: 'NEW',
  NOT_PUBLISHED: 'NOT PUBLISHED',
  PUBLISHED: 'PUBLISHED',
  HAS_CHANGES: 'HAS CHANGED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'NOT ACTIVE'
};

const getColorByStatus = status => {
  const { red, gradientGreenFirst, blackHover, gradientGreenSecond } = styles;

  switch (status) {
    case statusOptions.NEW:
      return gradientGreenFirst;
    case statusOptions.NOT_PUBLISHED:
    case statusOptions.INACTIVE:
      return blackHover;
    case statusOptions.PUBLISHED:
    case statusOptions.ACTIVE:
      return red;
    case statusOptions.HAS_CHANGES:
      return gradientGreenSecond;
    default: return red;
  }
};

const parseStatus = status => {
  switch (status) {
    case statusOptions.INACTIVE:
      return 'INACTIVE';
    case statusOptions.NOT_PUBLISHED:
      return 'UNPUBLISHED';
    default: return status;
  }
};

const LabeledStatusToggleButton = props => {
  const {
    status,
    loading,
    onClick,
    switchedOn,
    hideButton = false,
    label,
    className = '',
    size = 'standard'
  } = props;

  // const [loading, setLoading] = useState(false);
  // useEffect(() => setLoading(false), [status]);

  const handleOnClick = () => {
    if (loading) return;

    // setLoading(true);

    onClick();
  };

  return (
    <div className={`${styles.container} ${className}`}>
      {label &&
        <label>{label}</label>
      }
      <div>
        {!hideButton &&
          <ToggleButton
            switchedOn={switchedOn}
            loading={loading}
            onClick={handleOnClick}
            size={size}
          />}
        <span
          className={styles.status}
          style={{ color: getColorByStatus(status) }}
        >
          {parseStatus(status)}
        </span>
      </div>
    </div>
  );
};

export default LabeledStatusToggleButton;
